import { useEffect, useState, useMemo, useContext } from 'react';
import { StorageContext } from '../../context/StorageContext';
export function useVisitTrigger(_a) {
    var cdnCampaignIds = _a.cdnCampaignIds, isLoading = _a.isLoading, isVisTrigDisabled = _a.isVisTrigDisabled;
    var _b = useState(null), campaignTriggers = _b[0], setCampaignTriggers = _b[1];
    var _c = useContext(StorageContext), setVisitTriggers = _c.setVisitTriggers, getVisitTriggers = _c.getVisitTriggers, cleanupVisitTriggers = _c.cleanupVisitTriggers;
    var isIds = cdnCampaignIds.length > 0;
    useEffect(function () {
        if (isVisTrigDisabled || isLoading || !cdnCampaignIds.length) {
            return;
        }
        cleanupVisitTriggers(cdnCampaignIds);
    }, [cdnCampaignIds, isLoading]);
    useEffect(function () {
        if (isVisTrigDisabled || !isIds)
            return;
        var triggersFromStorage = getVisitTriggers();
        var triggers = cdnCampaignIds.map(function (campaignId) {
            var triggerFromStorage = triggersFromStorage.find(function (t) { return t.campaignId === campaignId; });
            var totalVisits = triggerFromStorage
                ? triggerFromStorage.totalVisits + 1
                : 1;
            return { campaignId: campaignId, totalVisits: totalVisits };
        });
        setCampaignTriggers(triggers);
    }, [cdnCampaignIds]);
    useEffect(function () {
        if (isVisTrigDisabled || campaignTriggers === null)
            return;
        setVisitTriggers(campaignTriggers);
    }, [campaignTriggers]);
    var dataWithTriggers = useMemo(function () {
        if (isVisTrigDisabled || campaignTriggers === null)
            return [];
        return campaignTriggers.map(function (_a) {
            var campaignId = _a.campaignId, totalVisits = _a.totalVisits;
            return ({
                id: campaignId,
                visit: totalVisits,
            });
        });
    }, [campaignTriggers]);
    return dataWithTriggers;
}
